var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"menu_btn",class:{ open: _vm.showHamburger, 'has-notification': _vm.notification.isEnabled },attrs:{"data-hamburger":"true"},on:{"click":_vm.toggleHamburger}},[_c('div',{staticClass:"menu_btn--burger"})])}
var staticRenderFns = []

export { render, staticRenderFns }